export default "__VITE_ASSET__D5r6rh9z__"